import { isAxiosError } from '../axiosHelpers';
export function isConflictError(error) {
  if (isAxiosError(error)) {
    return error.response?.status === 409;
  }
  return false;
}
export function isFieldError(error) {
  return isAxiosError(error) &&
  // eslint-disable-next-line eqeqeq
  error.response?.data?.globalErrors != undefined &&
  // eslint-disable-next-line eqeqeq
  error.response?.data?.fieldErrors != undefined;
}
export function isConflictErrorWithFields(error) {
  return isConflictError(error) && isFieldError(error);
}